import { render } from "./Facsimile.vue?vue&type=template&id=f4c1a9fe"
import script from "./Facsimile.vue?vue&type=script&lang=js"
export * from "./Facsimile.vue?vue&type=script&lang=js"

import "./Facsimile.vue?vue&type=style&index=0&id=f4c1a9fe&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__